import { sortCaret } from "../../../../../_metronic/_helpers";
import * as columnFormatters from "./registration-cancellation-report-table/column-formatters";

export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const sizePerPageList = [
  { text: "10", page: 10 },
  { text: "25", page: 25 },
  { text: "50", page: 50 },
  { text: "100", page: 100 }
];
export const initialFilter = {
  filter: {
    identityCard: {}
  },
  sortOrder: "desc", // asc||desc
  sortField: "date",
  pageNumber: 1,
  pageSize: 10
};
// Initial table columns
export const initialColumns = [
 {
    dataField: "photoStr",
    text: "Fotoğraf",
    formatter: columnFormatters.PhotoColumnFormatter,
    style: {
      minWidth: "100px"
    }
  },
  {
    dataField: "term",
    text: "Dönem",
    sort: true,
    width: 20,
    sortCaret: sortCaret,
    style: {
      minWidth: "100px"
    }
  },
  {
    dataField: "date",
    text: "Tarih",
    sort: true,
    width: 20,
    sortCaret: sortCaret,
    style: {
      minWidth: "130px"
    }
  },
  {
    dataField: "gradeLevelName",
    text: "Sınıf Düzeyi",
    sort: true,
    width: 20,
    sortCaret: sortCaret,
    style: {
      minWidth: "140px"
    }
  },
  {
    dataField: "grade",
    text: "Sınıf",
    sort: true,
    width: 20,
    sortCaret: sortCaret,
    style: {
      minWidth: "120px"
    }
  },
  {
    dataField: "studentNumber",
    text: "Öğrenci Numarası",
    sort: true,
    width: 20,
    sortCaret: sortCaret,
    style: {
      minWidth: "180px"
    }
  },
  {
    dataField: "identityCard.tcKimlikNo",
    text: "TC Kimlik No",
    sort: true,
    width: 20,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    }
  },
  {
    dataField: "identityCard.name",
    text: "Adı",
    sort: true,
    width: 25,
    sortCaret: sortCaret,
    style: {
      minWidth: "135px"
    }
  },
  {
    dataField: "identityCard.surname",
    text: "Soyadı",
    sort: true,
    width: 25,
    sortCaret: sortCaret,
    style: {
      minWidth: "135px"
    }
  },  
  {
    dataField: "sexName",
    text: "Cinsiyeti",
    sort: true,
    width: 20,
    sortCaret: sortCaret,
    style: {
      minWidth: "120px"
    }
  },
  {
    dataField: "address",
    text: "Adres",
    sort: true,
    width: 40,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "250px"
    }
  },
  {
    dataField: "father.name",
    text: "Baba Adı Soyadı",
    sort: true,
    width: 30,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "180px"
    }
  },
  {
    dataField: "mother.name",
    text: "Anne Adı Soyadı",
    sort: true,
    width: 30,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "180px"
    }
  },
  {
    dataField: "father.phone1",
    text: "Baba Telefonu",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    }
  },
  {
    dataField: "mother.phone1",
    text: "Anne Telefonu",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    }
  },
  {
    dataField: "father.occupation",
    text: "Baba Mesleği",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    }
  },  
  {
    dataField: "mother.occupation",
    text: "Anne Mesleği",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "150px"
    }
  },
  {
    dataField: "phone",
    text: "Öğrenci Telefonu",
    sort: true,
    width: 20,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "175px"
    }
  },
  {
    dataField: "explanation",
    text: "Açıklama",
    sort: true,
    width: 40,
    hidden: true,
    sortCaret: sortCaret,
    style: {
      minWidth: "250px"
    }
  },
  {
    dataField: "action",
    text: "İşlemler",
    hidden: true,
    classes: "text-right pr-0",
    headerClasses: "text-right pr-3",
    style: {
      minWidth: "110px"
    }
  }
];